// extracted by mini-css-extract-plugin
export var completionBody = "_kq-2";
export var completionCard = "_kq-0";
export var completionFooter = "_kq-3";
export var completionTitle = "_kq-1";